import { useEffect } from "react";
import { Box } from "@chakra-ui/react";
import Joi from "joi";

import { updateData } from "@ud/store/insertForm/insertSlice";
import StepButtons from "components/InsertOfferWrapper/components/StepButtons";
import useForm, { OnFormSubmitType } from "hooks/useForm";
import { SectionTitle } from "../components/SectionTitle";
import { useAppDispatch, useAppSelector } from "hooks/reduxHooks";
import { IconDocument } from "@ud/icons";
import Textarea from "components/Chakra/Textarea";
import { useTracking } from "contexts/Tracking";

type IDescription = {
  buttonNextText?: string;
  buttonPrevText?: string;
  handleNextStep: () => void;
};

type IFormValue = {
  description: string;
};

const formSchema = Joi.object({
  desxription: Joi.string(),
});

export const DescriptionFormThree: React.FC<IDescription> = ({
  buttonNextText,
  buttonPrevText,
  handleNextStep,
}) => {
  const { trackEvent } = useTracking();
  const dispatch = useAppDispatch();
  const insertReduxData = useAppSelector((e) => e.insertForm.data);

  const handleData: OnFormSubmitType<IFormValue> = ({ description }) => {
    dispatch(
      updateData({
        data: {
          description: description || undefined,
        },
      }),
    );
    trackEvent({
      "dl.eCat": "offer_create",
      "dl.eAct": "bttn.clicked",
      "dl.eLab": "6. krok – Popis",
    }),
      handleNextStep();
  };

  const { handleSubmit, watch, registerWithError } = useForm<IFormValue>(
    formSchema,
    {
      keepDataOnSuccess: true,
      defaultValues: {
        description: insertReduxData.description ?? "",
      },
    },
  );

  const checkIsBtnDisable = (): boolean =>
    [watchDescription].some((item) => !item);

  const watchDescription = watch("description");

  useEffect(
    () =>
      trackEvent({
        "dl.eCat": "offer_create",
        "dl.eAct": "page.loaded",
        "dl.eLab": "6. krok – Popis",
      }),
    [],
  );

  return (
    <form
      onSubmit={handleSubmit(handleData)}
      style={{
        flex: 1,
        display: "flex",
        flexDirection: "column",
        gap: 0,
        justifyContent: "space-between",
        width: "100%",
      }}
    >
      <Box textAlign="left">
        <SectionTitle
          icon={<IconDocument boxSize="16px" fillWith="ud-grey-600" />}
          title="Popisek inzerátu"
          isRequired
        />

        <Textarea
          {...registerWithError("description")}
          bg="ud-white"
          placeholder="Představte nemovitost zájemcům, jaké jsou její přednosti a co jí vystihuje."
          h="250px"
          sx={{
            borderWidth: "1px",
            borderColor: "ud-grey-300",
            borderStyle: "solid",
            _focusVisible: {
              borderWidth: "1px",
              borderColor: "ud-grey-500",
              borderStyle: "solid",
            },
          }}
        />
      </Box>
      <StepButtons
        buttonPrevText={buttonPrevText}
        buttonNextText={buttonNextText}
        checkIsBtnDisable={checkIsBtnDisable}
        mt={[null, "24px"]}
      />
    </form>
  );
};
